// extracted by mini-css-extract-plugin
export default {"edit-button":"Tags_edit-button__9gxBS","tags":"Tags_tags__Ye0wX","loading-value":"Tags_loading-value__iKfjt"};